/**
 * This trainings/courses search module works on top of "PCG.UmbracoPlugins.TrainingsSearch" plugin.
 * It is used by the "Learning Hub" section of the "County Council" site. See "TrainingsListingPage" for details.
 */

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";

import { PaginationComponent } from "./components/pagination/pagination.component";
import { CategoriesFilterComponent } from "./components/search-filters/categories-filter/categories-filter.component";
import { CheckboxComponent } from "./components/search-filters/categories-filter/checkbox/checkbox.component";
import { DatesFilterComponent } from "./components/search-filters/dates-filter/dates-filter.component";
import { SearchFiltersComponent } from "./components/search-filters/search-filters.component";
import { ResultItemComponent } from "./components/search-results/result-item/result-item.component";
import { SearchResultsComponent } from "./components/search-results/search-results.component";
import { TrainingsSearchComponent } from "./trainings-search.component";

@NgModule({
    imports: [
        CommonComponentsModule,
        CommonModule
    ],
    declarations: [
        CategoriesFilterComponent,
        CheckboxComponent,
        DatesFilterComponent,
        TrainingsSearchComponent,
        PaginationComponent,
        ResultItemComponent,
        SearchFiltersComponent,
        SearchResultsComponent
    ],
    exports: [
        TrainingsSearchComponent
    ]
})
export class TrainingsSearchModule {
}
